var map = {
	"./paciente-banco.mp4": 9925,
	"./paciente-feliz.mp4": 4626,
	"./paciente-frente.mp4": 5196,
	"./paciente-pensando.mp4": 553,
	"./paciente-primer-plano.mp4": 3755,
	"./paciente-tablet.mp4": 7945,
	"./paciente-ventana.mp4": 8021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1812;